import styled from 'styled-components'

export const FormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-bottom: 24px;
`

export const PasswordWrapper = styled.div`
  display: flex;
  align-items: end;
`
